import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { Clock } from 'lucide-react';
export function CountdownBar() {
  const timeLeft = useCountdown(11);
  return <div className="fixed top-0 left-0 w-full bg-[#2563eb] text-white py-2 z-50 text-center font-bold text-sm md:text-base shadow-md" data-id="element-10">
      <div className="flex items-center justify-center gap-2" data-id="element-11">
        <Clock className="w-4 h-4" data-id="element-12" />
        <span data-id="element-13">OFERTA EXPIRA EN: {timeLeft} | SOLO QUEDAN 3 CUPOS</span>
      </div>
    </div>;
}